import React, { Component } from 'react';
import pack from '../../package.json';
import { Modal } from '../components';
import './Version.scss';
import { COLORMAP } from '../styles/index.js';
import { Icon } from '@material-ui/core';

const PATCHNOTES_DATE = 1550872187369;

class Version extends Component {
  state = { modalShown: false, newNotes: false };

  UNSAFE_componentWillMount() {
    const lastViewedPatchNotes = localStorage.lastViewedPatchNotes;
    if (!lastViewedPatchNotes || lastViewedPatchNotes < PATCHNOTES_DATE) {
      this.setState({ newNotes: true });
    }
  }

  showPatchNotes() {
    this.setState({ modalShown: true, newNotes: false });
    localStorage.lastViewedPatchNotes = Date.now();
  }

  renderBadge() {
    if (this.state.newNotes) {
      return (<div className="badge" style={{ backgroundColor: COLORMAP.orange }} />);
    }
  }

  render() {
    return (
      <div>
        <div id="version" onClick={this.showPatchNotes.bind(this)}>
          {pack.version}
          {this.renderBadge()}
        </div>

        <Modal width={650} showModal={this.state.modalShown} closeModal={() => this.setState({ modalShown: false })}>
          <div id="patchnotes">
            <Icon className="close-patch-notes" onClick={() => this.setState({ modalShown: false })} >close</Icon>
            <h1>version 1.0</h1>
            <h2><span role="img" aria-label="party-hat">🎉</span> What's new?!</h2>
            <p>
              Hey, and thanks for checking out Prism's patch notes! Here's all of the stuff we've added and fixed.
            </p>
            <p>
              <b><span role="img" aria-label="present">🎁</span> New Stuff</b>
            </p>
            <ul>
              <li>Prism now has <b>Administration tools!</b> Admins can:
                <ul>
                  <li>Reset a user’s achievements. Back to Level 1, kiddo</li>
                  <li>Delete any shoutout whose contents are too spicy</li>
                  <li>Deactivate users when they leave the company or post content that is too spicy</li>
                </ul>
              </li>
              <li>You can now <b>delete</b> your own shoutouts!</li>
              <li>The comments modal for a shoutout has been redesigned. Comments will appear with the oldest at the top and most recent on the bottom,
                as they do in every other site on the internet. </li>
              <li><b>Personalize</b> your profile page by setting your Job Title and writing a short Biography about your self. </li>
              <li>While on a user’s profile, filter the shoutouts shown to see what shoutouts they have sent and what they’ve received</li>
            </ul>
            <p>
              <b><span role="img" aria-label="bug">🐛 </span> Bugs Squished</b>
            </p>
            <ul>
              <li>TV Mode filtering options are remembered after refreshing in TV Mode</li>
              <li>When a comment is made, the number of comments is updated in real time. When shoutouts are sent,
                the shoutouts sent/received is updated on a user’s profile. </li>
              <li>Image upload is actually usable on Mobile!</li>
              <li>Clicking the white-space next to an image will no longer open it. </li>
            </ul>
          </div>
        </Modal>
      </div>
    );
  }
}

export default Version;


// WEBPACK FOOTER //
// ./src/components/Version.js